export default __webpack_public_path__ + "static/media/chris-PFP.824493f1.png";